import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/UseAuth"; 
import { ReactNode } from "react";

export const RedirectIfLoggedIn = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();

  if (user) {
      // If no history, redirect to a default page
      return <Navigate to="/feed" replace />;
  }

  return <>{children}</>;
};
